import styled from 'styled-components';

import { Heading, Colors } from '@notino/react-styleguide';

export const IconTextButton = styled.div`
  color: ${(props) => props.theme.palette.neutralDark};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4.6875rem;
  cursor: pointer;
  svg {
    color: black;
  }
  transition: color 100ms ease;
  &:hover {
    color: ${(props) => props.theme.palette.neutralDarker};
  }
`;

export const CircleBorder = styled.div`
  border: 1px solid ${(props) => props.theme.palette.neutralDark};
  border-radius: 100%;
  display: flex;
  margin-right: 0.9375rem;
`;

export const LinkSharerCircleBorder = styled(CircleBorder)`
  padding: 0.4375rem 0.4375rem 0.5625rem 0.5625rem;
`;

export const ModalBody = styled.div`
  padding: 0 1.875rem;
`;

export const H3 = styled(Heading.H3)`
  margin: 1.875rem 0 2.5rem;
`;

export const LinkLabel = styled.label`
  display: inline-block;
  width: 100%;
  text-align: left;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const LinkInput = styled.input`
  color: ${(props) => props.theme.palette.neutralDark};
  font-weight: 300;
  box-sizing: border-box;
  width: 100%;
  padding: 0.9375rem;
  margin-bottom: 1.75rem;
`;

export const Message = styled.div<{ color: Colors }>`
  color: ${(props) => props.theme.palette[props.color]};
  box-sizing: border-box;
  width: 100%;
  height: 1rem;
  margin: 0 0 1.9375rem;
  display: inline-flex;
  svg {
    width: 18px;
  }
`;
